/**
 * Sanitizes HTML to only allow <mark> tags.
 * Strips all other HTML tags for security.
 */
export function sanitizeReviewText(text: string): string {
	// Escape everything first, then restore only <mark> and </mark>
	return text
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/&lt;mark&gt;/g, "<mark>")
		.replace(/&lt;\/mark&gt;/g, "</mark>");
}
